import React from 'react';
import {observer} from "mobx-react";
import { PromotionSlideBox } from './boxes/promotion-slide.box';
import {useServices} from "../../../../react-hooks/use-services.hook";
import {
    CasinoArenaPromotionalBannerConfiguration
} from "../../../../services/configurations/config-data-sections/arenas.configuration";
import {BannerComponent} from "../../../banner/banner.component";

interface PromotionSlideComponentProps {

}
let componentIndex = 0;
export const PromotionSlideComponent: React.FC<PromotionSlideComponentProps> = observer(() => {
    const services = useServices();
    const currentComponentIndex = componentIndex++;
    let bannerConfig:CasinoArenaPromotionalBannerConfiguration = services.configuration.data.arenas.videoSlidesArena.promotionalBanner;
    return <PromotionSlideBox>
        <div style={{gridRowStart:2, gridRowEnd:3}}>
        <BannerComponent key={`Promotions_${currentComponentIndex}`}
                            className={'vertical-swiper-banner'}
                            showPlaceholder={false}
                            componentID={bannerConfig.componentID}
                            templateID={bannerConfig.templateID}
                            bannerAdminPlaceholderId={bannerConfig.bannerAdminPlaceholderId}
                            fallbackComponent={bannerConfig.fallbackComponent}
        /></div>
    </PromotionSlideBox>
})